// @ts-nocheck
import { Ref, RefObject, useRef } from "react";

export default <T>(ref: Ref<T>) => {
    const baseRef = useRef<T>(undefined);

    return (ref as RefObject<T>) || baseRef;
};
